import { IImageBaseViewModel } from 'Types/Litium';
import { dpr } from 'Utils/dpr';
import { getNewDimensionsWithAspectRatio } from 'Utils/getNewDimensionsWithAspectRatio';
import tailwindBreakpoints from 'Utils/tailwindBreakpoints';

const PartnerSectionImage = ({ image }: { image: IImageBaseViewModel }) => (
    <picture>
        <source
            width={
                image.width > 0
                    ? getNewDimensionsWithAspectRatio(
                          image.width,
                          image.height,
                          40,
                          'width'
                      )
                    : ''
            }
            height={image.height > 0 ? 40 : ''}
            media={`(min-width: ${tailwindBreakpoints.lg})`}
            srcSet={`${image.src}?format=webp&height=40`}
        />
        <img
            className="h-8 max-w-max lg:h-10"
            height={image.height > 0 ? 32 : ''}
            width={
                image.width > 0
                    ? getNewDimensionsWithAspectRatio(
                          image.width,
                          image.height,
                          32,
                          'width'
                      )
                    : ''
            }
            src={`${image.src}?format=webp&height=32`}
            srcSet={dpr(`${image.src}?format=webp&height=32`)}
            alt={image.altText}
        />
    </picture>
);

export default PartnerSectionImage;
